<template>
  <v-container>
    <v-select v-model="cliente" :items="selectClientes" label="Cliente" outline></v-select>
    <v-expansion-panel v-if="cliente" popout>
      <v-expansion-panel-content v-for="(trabajo,i) in clientes[cliente].trabajos" :key="i">
        <template v-slot:header>
          <div>
            <strong>{{ trabajo.referencia }}</strong> {{ trabajo.direccion }} {{ trabajo.municipio }}
            <v-icon v-show="trabajo[rol.replace(' ', '')].firma" color="blue" title="Ya firmado">check</v-icon>
            <v-icon v-if="rol.substring(0,1)=='t'" v-show="trabajo[rol.replace('tecnico ', 'capataz')].firma" title="Firmado por el capataz">check</v-icon>
            <v-icon v-else v-show="trabajo[rol.replace('capataz ', 'tecnico')].firma" color="grey" title="Firmado por el técnico">check</v-icon>
            <br>
            <strong>{{ trabajo.clasificacion && trabajo.clasificacion.referencia }}</strong>  {{ trabajo.clasificacion && trabajo.clasificacion.descripcion }}
          </div>
        </template>
        <v-card>
          <v-layout wrap>
            <v-flex>
              <v-container>
                <v-card>
                  <v-card-title>
                    <strong>Referencia:</strong>
                    {{ trabajo.referencia }}
                  </v-card-title>
                </v-card>
              </v-container>
            </v-flex>
            <v-flex>
              <v-container>
                <v-card>
                  <v-card-title>
                    <strong>Dirección:</strong>
                    {{ trabajo.direccion }}
                  </v-card-title>
                </v-card>
              </v-container>
            </v-flex>
            <v-flex>
              <v-container>
                <v-card>
                  <v-card-title>
                    <strong>Imputación:</strong>
                    {{ trabajo.imputacion }}
                  </v-card-title>
                </v-card>
              </v-container>
            </v-flex>
            <v-flex>
              <v-container>
                <v-card>
                  <v-card-title>
                    <strong>Municipio:</strong>
                    {{ trabajo.municipio }}
                  </v-card-title>
                </v-card>
              </v-container>
            </v-flex>
          </v-layout>
          <v-container>
            <v-card v-for="tarea in trabajo.tareas" :key="tarea.originId" class="my-3">
              <v-card-title>{{ tarea.referencia }} - {{ tarea.descripcion }}</v-card-title>
              <v-data-table :items="tarea.codigos" :headers="headers" hide-actions>
                <template v-slot:items="props">
                  <td>{{ props.item.codigo }}</td>
                  <td>{{ props.item.descripcion }}</td>
                  <td>{{ props.item.dm }}</td>
                  <td class="text-xs-right">{{ props.item.unidades }}</td>
                  <td class="text-xs-right">{{ props.item.precio }}&nbsp;€</td>
                  <td class="text-xs-right">{{ props.item.unidades * props.item.precio }}&nbsp;€</td>
                </template>
                <template v-slot:footer>
                  <td :colspan="headers.length" class="text-xs-right">
                    <strong>{{ importe(tarea).toFixed(2) }} €</strong>
                  </td>
                </template>
              </v-data-table>
            </v-card>
            <div v-if="trabajo.tareas && trabajo.tareas.length > 1" class="text-xs-right">
              <strong>Total:</strong>
              {{ total(trabajo).toFixed(2) }} €
            </div>
            <v-layout>
              <v-flex class="mx-1">
                <div class="subheading">Vº Bº capataz de Hidralia</div>
                <firma
                  :rol="rol"
                  :indice="i"
                  v-if="rol=='capatazHidralia' && !trabajo.capatazHidralia.firma"
                  @enviar="enviarFirma(trabajo, 'capatazHidralia', $event)"
                ></firma>
                <v-responsive
                  v-else
                  :aspect-ratio="21/13"
                  max-width="500"
                  class="my-3"
                  style="border: 1px solid black"
                >
                  <v-img :src="trabajo.capatazHidralia.firma"></v-img>
                </v-responsive>
              </v-flex>
              <v-flex class="mx-1">
                <div class="subheading">Vº Bº capataz de Acocasa</div>
                <firma
                  :rol="rol"
                  :indice="i"
                  v-if="rol=='capatazAcocasa' && !trabajo.capatazAcocasa.firma"
                  @enviar="enviarFirma(trabajo, 'capatazAcocasa', $event)"
                ></firma>
                <v-responsive
                  v-else
                  :aspect-ratio="21/13"
                  max-width="500"
                  class="my-3"
                  style="border: 1px solid black"
                >
                  <v-img :src="trabajo.capatazAcocasa.firma"></v-img>
                </v-responsive>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex class="mx-1">
                <div class="subheading">Vº Bº técnico de Acocasa</div>
                <firma
                  :rol="rol"
                  :indice="i"
                  v-if="rol=='tecnicoAcocasa' && !trabajo.tecnicoAcocasa.firma"
                  @enviar="enviarFirma(trabajo, 'tecnicoAcocasa', $event)"
                ></firma>
                <v-responsive
                  v-else
                  :aspect-ratio="21/13"
                  max-width="500"
                  class="my-3"
                  style="border: 1px solid black"
                >
                  <v-img :src="trabajo.tecnicoAcocasa.firma"></v-img>
                </v-responsive>
              </v-flex>
              <v-flex class="mx-1">
                <div class="subheading">Vº Bº técnico de Hidralia</div>
                <firma
                  :rol="rol"
                  :indice="i"
                  v-if="rol=='tecnicoHidralia' && !trabajo.tecnicoHidralia.firma"
                  @enviar="enviarFirma(trabajo, 'tecnicoHidralia', $event)"
                ></firma>
                <v-responsive
                  v-else
                  :aspect-ratio="21/13"
                  max-width="500"
                  class="my-3"
                  style="border: 1px solid black"
                >
                  <v-img :src="trabajo.tecnicoHidralia.firma"></v-img>
                </v-responsive>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex></v-flex>
              <v-flex></v-flex>
            </v-layout>
            <v-img v-for="(foto, i) in trabajo.fotos" :key="i" :src="`https://api2.acocasa.com${foto}`"></v-img>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
import Firma from '../components/Firma'

export default {
  components: {
    firma: Firma
  },
  computed: {
    selectClientes () {
      var res = []
      Object.keys(this.clientes).forEach(id => {
        res.push({ value: id, text: this.clientes[id].nombre })
      })
      return res
    }
  },
  created () {
    this.axios.get('trabajos/',
    { params: { token: this.$route.params.token}}
    ).then(response => {
      var clientes = {}
      response.data.trabajos.forEach(trabajo => {
        if (clientes[trabajo.cliente]) {
          // trabajo.tareas = JSON.parse(trabajo.tareas)
          clientes[trabajo.cliente].trabajos.push(trabajo)
        } else {
          clientes[trabajo.cliente] = { nombre: trabajo.cliente, trabajos: [trabajo] }
        }
      })
      Object.values(clientes).forEach(cliente => {
        cliente.trabajos.sort((a, b) => {
          if (a.fecha < b.fecha) return -1
          else if (a.fecha > b.fecha) return 1
          else return 0
        })
      })
      this.clientes = clientes
      this.rol = response.data.rol
    })
  },
  data () {
    return {
      cliente: '',
      clientes: {},
      headers: [
        {
          text: 'Código',
          sortable: false
        },
        {
          text: 'Descripción',
          sortable: false
        },
        {
          text: 'DM',
          sortable: false
        },
        {
          text: 'Uds',
          sortable: false
        },
        {
          text: 'Precio',
          sortable: false
        },
        {
          text: 'Total',
          sortable: false
        }
      ],
      rol: '',
      // trabajos: ''
    }
  },
  methods: {
    enviarFirma (trabajo, rol, data) {
      var params = {}
      params.rol = this.rol
      params.firma = data
      params.token = this.$route.params.token
      this.axios.patch(`trabajos/${trabajo.id}/`, params).then(response => {
        this.$set(trabajo[rol], 'firma', data)
      })
    },
    importe (tarea) {
      var total = 0
      tarea.codigos.forEach(codigo => {
        total += codigo.precio * codigo.unidades
      })
      return total
    },
    total (trabajo) {
      var total = 0
      trabajo.tareas.forEach(tarea => {
        total += this.importe(tarea)
      })
      return total
    }
  }
}
</script>
